import { render, staticRenderFns } from "./query-order-wording.vue?vue&type=template&id=2634672e"
import script from "./query-order-wording.vue?vue&type=script&lang=js"
export * from "./query-order-wording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports